<template>
  <div class="uploader-container">
    <div class="uploader">
      <div class="row">
        <div class="col-6">
          <div class="form-group">
            <label for="title">Select Video Types</label>
            <select
              class="form-control"
              id="videoType"
              v-model="videoType"
              @change="handleVideoType"
              >
              <option value="upload">Upload</option>
              <option value="cloudflare">Cloudflare ID</option>

            </select>
          </div>
        </div>
      </div>
      <div
        aria-live="polite"
        aria-atomic="true"
        aria-relevant="text"
        class="upload"
      >
        <div role="button"
            @click="handleFileUpload"
        >
          <input
            type="file"
            name="file"
            id="file"
            class="d-none"
            accept="video/*"
            ref="file"
          />
          <div class="before-upload-stage upload-card">
            <svg
              fill="currentColor"
              viewBox="0 0 48 48"
              xmlns="http://www.w3.org/2000/svg"
              width="1em"
              height="1em"
              style="
                color: var(--tux-colorTextQuaternary);
                width: 48px;
                height: 48px;
              "
            >
              <path
                d="M25.84 37h8.66a9.5 9.5 0 0 0 1.35-18.9A12 12 0 0 0 12 20v.01A8.5 8.5 0 0 0 12.5 37h10.34V25.6l-1.72 1.74a1 1 0 0 1-1.42 0l-.7-.7a1 1 0 0 1 0-1.41l4.4-4.4c.68-.76 1.22-.77 2 .08l4.28 4.32a1 1 0 0 1 0 1.4l-.7.72a1 1 0 0 1-1.42 0l-1.72-1.75V37Z"
              ></path>
            </svg>
            <div class="text-main">
              <span> Select video to upload </span>
            </div>
            <div class="text-sub">
              <span> or drag and drop video files </span>
            </div>
            <div class="text-video-info">
              <ul>
                <li>Video must be in MP4 format</li>
                <li>Video must be less than 2GB</li>
                <li>Video must be less than 2 hours</li>
              </ul>
            </div>
            <div class="btn ">
                <button
                    type="button"
                    class="btn "
                    style="letter-spacing: 3px"
                >
                    Upload Video
                </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'uploaderInput',
  data() {
    return {
      file: '',
      fileRef: null,
    };
  },
  mounted() {
    this.fileRef = this.$refs.file;
  },
  data() {
    return {
      videoType: 'upload',
    };
  },
  methods: {
    handleFileUpload() {
      this.fileRef.click();

        this.fileRef.addEventListener('change', (e) => {
            this.file = e.target.files[0];
            const reader = new FileReader();
        reader.onload = (event) => {
          const videoUrl = event.target.result;
          this.$emit('handleVideoUpload', { file: this.file,videoUrl :videoUrl });
        };
        reader.readAsDataURL(this.file);
        });
    }
    ,
    handleVideoType() {
      this.$emit('handleVideoType', this.videoType);
    },
  },

};
</script>

<style scoped>
.uploader-container {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border-radius: 8px;
  background-color: #fff;
  padding: 34px 50px;
}
.before-upload-stage {
  border-radius: 8px;
  display: flex;
  -webkit-box-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  align-items: center;
  flex-direction: column;
  cursor: pointer;
  transition: background 0.15s ease-in-out 0s;
  padding-left: 35px;
  padding-right: 35px;
}
.upload-card {
  border: 2px dashed rgb(22, 24, 35);
  width: 100%;
  height: 458px;
  display: flex;
  -webkit-box-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  align-items: center;
  box-sizing: border-box;
}
.upload-card .text-main {
  text-align: center;
  margin-top: 24px;
}
.text-main span {
  box-sizing: border-box;
  margin-block: 0px;
  line-height: 1.5;
  color: rgba(22, 24, 35, 1);
}
.text-sub {
  margin-top: 4px;
  margin-bottom: 24px;
  text-align: center;
}
.text-sub span {
  box-sizing: border-box;
  margin-block: 0px;
  line-height: 1.5;
  color: rgba(22, 24, 35, 0.5);
}
.text-video-info {
  margin-top: 24px;
  margin-bottom: 24px;
  text-align: center;
  color: rgb(115, 116, 123);
  list-style: none;
}
.btn .btn{
    background-color: #0f4c47;
    border-color: #0f4c47;
    color: #fff;
    border-radius: 5px;
    padding: 0 20px;
    height: 45px;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 3px;
    text-transform: uppercase;
    transition: all 0.3s;
}
</style>
